// src/components/Scale5RadarChart.js
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
} from 'chart.js';
import axios from 'axios';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

function Scale5RadarChart({ surveyId }) {
  const { t, i18n } = useTranslation();
  const [analysis, setAnalysis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // WICHTIG: i18n.language als Dependency!
  useEffect(() => {
    async function loadData() {
      try {
        const res = await axios.get(
          `/survey/surveys/${surveyId}/analysis-scale5`,
          { withCredentials: true }
        );
        setAnalysis(res.data.scale5_analysis || []);
      } catch (err) {
        setError(
          err.response?.data?.error ||
            t('radar.loadError', 'Fehler beim Laden der Radar-Daten')
        );
      }
      setLoading(false);
    }

    if (surveyId) {
      loadData();
    }
  // HIER: i18n.language als Dependency!
  }, [surveyId, t, i18n.language]);

  if (loading) {
    return <p>{t('radar.loading', 'Lade Radar-Daten...')}</p>;
  }
  if (error) {
    return <p style={{ color: 'red' }}>{error}</p>;
  }
  if (analysis.length === 0) {
    return <p>{t('radar.noQuestions', 'Keine scale_5-Fragen gefunden oder keine Antworten.')}</p>;
  }

  // Labels übersetzen: entweder echte Fragentexte oder „Frage X“
  const labels = analysis.map((a) =>
    // a.question_text || 
    `${t('radar.question', 'Frage')} ${a.order_index + 1}`
  );

  const dataValues = analysis.map((a) =>
    a.average ? parseFloat(a.average) : 0
  );

  const data = {
    labels,
    datasets: [
      {
        label: t('radar.avgLabel', 'Durchschnitt (1..5)'),
        data: dataValues,
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 2
      }
    ]
  };

  const options = {
    scales: {
      r: {
        min: 1,
        max: 5,
        ticks: {
          stepSize: 1,
          callback: function (value) {
            if (value === 1)
              return t('radar.label1', '1 = Trifft gar nicht zu');
            if (value === 5)
              return t('radar.label5', '5 = Trifft voll zu');
            return value;
          }
        }
      }
    },
    plugins: {
      legend: {
        labels: {
          generateLabels: (chart) => {
            const defaultLabels = ChartJS.defaults.plugins.legend.labels.generateLabels(chart);
            if (defaultLabels.length === 1) {
              defaultLabels[0].text = t('radar.avgLabel', 'Durchschnitt (1..5)');
            }
            return defaultLabels;
          }
        }
      }
    }
  };

  return (
    <div style={{ width: '600px', margin: '1rem auto' }}>
      <h3>{t('radar.heading', 'Antwortauswertung (5 = "Trifft voll zu", 1 = "Trifft gar nicht zu")')}</h3>
      <Radar data={data} options={options} />
    </div>
  );
}

export default Scale5RadarChart;
